import { ACTIONS } from '../const';
import { switcher, combineReducers } from './utils';

const v3uri = uri => (uri != null ? uri.replace('v4', 'v3') : uri);

const userRecord = (data = {}) => {
    const user = {
        resource_uri: null,
        v3_uri: null,
        id: null,
        email: null,
        instructor_in: [],
        full_name: null,
        first_name: null,
        last_name: null,
        preferences: null,
        eula: null,
        hide_sharing_qa: true,
        ...data,
    };

    return {
        ...user,
        v3_uri: v3uri(user.resource_uri),
    };
};

const user = switcher(userRecord(), {
    [ACTIONS.SYNC_USER](state, action) {
        return userRecord(action.user);
    },
});

const other = switcher(
    { csrf: null },
    {
        [ACTIONS.SYNC_CSRF](state, action) {
            return {
                ...state,
                csrf: action.token,
            };
        },
    }
);
const preferences = switcher(
    {},
    {
        [ACTIONS.MERGE_PREFERENCES](state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
        [ACTIONS.SYNC_PREFERENCES](state, action) {
            return {
                ...state,
                ...action.preferences,
            };
        },
    }
);

export default combineReducers(
    {
        user,
        preferences,
        other,
    },
    false
);



// WEBPACK FOOTER //
// ./src/reducers/current_user.js